// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__NlAwa","modal__title":"styles_modal__title__ct643","modal__footer":"styles_modal__footer__KebU7"};